import { NodeShapeMixin } from "../lib/NodeShape.mjs";
import { PropertyShapeMixin } from "../lib/PropertyShape.mjs";
import { RuleMixin } from "../lib/Rule.mjs";
import { SeverityMixin } from "../lib/Severity.mjs";
import { ShapeMixin } from "../lib/Shape.mjs";
import { SPARQLConstraintMixin } from "../lib/SPARQLConstraint.mjs";
import { TargetMixin } from "../lib/Target.mjs";
export const ShapeBundle = [NodeShapeMixin, PropertyShapeMixin, RuleMixin, SeverityMixin, ShapeMixin, SPARQLConstraintMixin, TargetMixin];